import { Link } from 'react-router-dom';
import Header from '../../components/Layout/Header';
import Footer from '../../components/Layout/Footer';
import './Auth.css';

const VolunteerLoginComingSoon = () => (
  <div className="login-page-wrapper">
    <Header />
    <div className="login-page login-page--coming-soon">
      <div className="login-container login-container--single">
        <div className="login-form-card volunteer-coming-soon-card">
          <div className="login-form-header">
            <h1 className="login-title">Volunteer sign-in</h1>
            <p className="login-subtitle">Coming soon</p>
          </div>
          <p className="volunteer-coming-soon-text">
            We&apos;re building a dedicated way for volunteers to sign in. Check back later, or use the main
            sign-in if you already have an Invincible account.
          </p>
          <Link to="/login" className="submit-btn-primary volunteer-coming-soon-back">
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default VolunteerLoginComingSoon;
